import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  flex-direction: column;
  background: ${props => props.theme.colors.background};
  gap: 16px;
  border-radius: 8px; 
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 16px;
    background: ${props => props.theme.colors.inputBackground};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-transform: capitalize;
`;

export const Content = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: start;
`;

export const FileName = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
`;